import { EventEmitter } from '../../utils';
import { MARKS } from '../../constants';

export const keyMappings = {
  markBold: 'ctrl+b',
  markItalic: 'ctrl+i',
  markUnderline: 'ctrl+u',
  openHotkeyModal: 'ctrl+,',
  openImagePopup: 'ctrl+shift+i',
  openLinkPopup: 'ctrl+shift+l',
  openTablePopup: 'ctrl+shift+t',
  openSnippetPopup: 'ctrl+shift+s',
  toggleFullscreen: 'ctrl+shift+f',
};

export const handlerMappings = {
  markBold: event => {
    event.preventDefault();
    EventEmitter.emit('mark-hotkey', MARKS.BOLD);
  },
  markItalic: event => {
    event.preventDefault();
    EventEmitter.emit('mark-hotkey', MARKS.ITALIC);
  },
  markUnderline: event => {
    event.preventDefault();
    EventEmitter.emit('mark-hotkey', MARKS.UNDERLINE);
  },
  openHotkeyModal: event => {
    event.preventDefault();
    EventEmitter.emit('open-modal--hotkey');
  },
  openImagePopup: event => {
    event.preventDefault();
    EventEmitter.emit('open-popup--image');
  },
  openLinkPopup: event => {
    event.preventDefault();
    EventEmitter.emit('open-popup--link');
  },
  openTablePopup: event => {
    event.preventDefault();
    EventEmitter.emit('open-popup--table');
  },
  openSnippetPopup: event => {
    event.preventDefault();
    EventEmitter.emit('open-popup--snippet');
  },
  toggleFullscreen: event => {
    event.preventDefault();
    EventEmitter.emit('toggleFullscreen');
  },
};
